export const OPEN_SIDEBAR = "OPEN_SIDEBAR";
export const OPEN_SIDEBAR_RIGHT = "OPEN_SIDEBAR_RIGHT";
export const OPEN_SIDEBAR_MOBILE = "OPEN_SIDEBAR_MOBILE";
export const CHANGE_ACTIVE_SIDEBAR_ITEM = "CHANGE_ACTIVE_SIDEBAR_ITEM";
